// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1zXRb","rightAdornment":"Header_rightAdornment__yeEjS"};